import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { connect } from 'react-redux';
import Sessions from "./components/blocks/Sessions/Sessions";
import Home from "./components/pages/Home/Home";
import Signin from "./components/pages/Signin/Signin";
import Forgot from "./components/pages/Forgot/Forgot";
import ResetPassword from "./components/pages/ResetPassword/ResetPassword";
import Register from "./components/pages/Register/Register";
import VerifyEmail from "./components/pages/VerifyEmail/VerifyEmail";
import Feature from "./components/pages/Feature/Feature";
import Pricing from "./components/pages/Pricing/Pricing";
import PrivacyPolicy from "./components/pages/PrivacyPolicy/PrivacyPolicy";
import Contact from "./components/pages/Contact/Contact";
import ControlCenter from './components/blocks/ControlCenter/ControlCenter';
import Profile from './components/pages/Profile/Profile';
import Dashboard from './components/pages/Dashboard/Dashboard';
import Company from './components/pages/Company/Company';
import User from './components/pages/User/User';
import Documentation from './components/pages/Documentation/Documentation';
import Workspace from './components/pages/Workspace/Workspace';
import Connection from './components/pages/Connection/Connection';
import Storage from './components/pages/Storage/Storage';
import Schedule from './components/pages/Schedule/Schedule';
import TermsOfUse from './components/pages/TermsOfUse/TermsOfUse';

import BackDropLoading from './components/blocks/BackDrop/BackDrop';
import ConfirmDialogSimple from './components/blocks/ConfirmDialog/ConfirmDialog';
import SnackbarAlertSimple from './components/blocks/SnackbarAlert/SnackbarAlert';

import {
  AuthToken,
  Signout,
} from "./services/Auth.service"

function App(props) {
  const { UserInfor, BackDrop, ConfirmDialog, SnackbarAlert } = props;

  useEffect(() => {
    AuthToken()
    .then(res => {
      localStorage.setItem('_userinfor', JSON.stringify(res.data));
      props.dispatch({ type: 'UPDATE_USER_INFOR', UserInfor: res.data });
    })
    .catch(err => {
      Signout();
      localStorage.setItem('_userinfor', JSON.stringify({}));
      props.dispatch({ type: 'UPDATE_USER_INFOR', UserInfor: {}});
    })
  }, [])

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Sessions />}>
            <Route index element={<Navigate replace to="/signin" />} />
            {/* <Route path="/feature" element={<Feature />} /> */}
            {/* <Route path="/pricing" element={<Pricing />} /> */}
            {/* <Route path="/terms-of-use" element={<TermsOfUse />} /> */}
            {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
            {/* <Route path="/contact" element={<Contact />} /> */}
            {/* <Route path="/contact/:form" element={<Contact />} /> */}
            <Route path="/signin" element={(UserInfor?.verifyEmailFlg !== undefined) ? <Navigate replace to="/verify-email" /> : <Signin />} />
            <Route path="/forgot-password" element={(UserInfor?.verifyEmailFlg !== undefined) ? <Navigate replace to="/verify-email" /> : <Forgot />} />
            <Route path="/reset-password/:token" element={(UserInfor?.verifyEmailFlg !== undefined) ? <Navigate replace to="/verify-email" /> : <ResetPassword />} />
            <Route path="/password-expired/:token" element={(UserInfor?.verifyEmailFlg !== undefined) ? <Navigate replace to="/verify-email" /> : <ResetPassword />} />
            {/* <Route path="/register/:plan/:payments" element={(UserInfor?.verifyEmailFlg !== undefined) ? <Navigate replace to="/verify-email" /> : <Register />} /> */}
            {/* <Route path="/register/:plan" element={(UserInfor?.verifyEmailFlg !== undefined) ? <Navigate replace to="/verify-email" /> : <Register />} /> */}
            <Route path="/verify-email/:token" element={UserInfor?.verifyEmailFlg === 1 ? <Navigate replace to="/control-center/dashboard" /> : <VerifyEmail />} />
            <Route path="/verify-email" element={UserInfor?.verifyEmailFlg === 1 ? <Navigate replace to="/control-center/dashboard" /> : (UserInfor?.verifyEmailFlg === undefined) ? <Navigate replace to="/signin" /> : <VerifyEmail />} />
            <Route path="*" element={<Navigate replace to="/verify-email" />} />
          </Route>
          <Route path="/control-center" element={ UserInfor?.verifyEmailFlg === 1 ? <ControlCenter /> : UserInfor?.verifyEmailFlg === undefined ? <Navigate replace to="/signin"/> : <Navigate replace to="/verify-email"/>}>
            <Route path="/control-center/profile" element={<Profile />} />
            <Route path="/control-center/dashboard" element={<Dashboard />} />
            <Route path="/control-center/company" element={(parseInt(UserInfor?.roleID) === 1) ? <Company /> : <Navigate replace to="/control-center/dashboard" />} />
            <Route path="/control-center/user" element={(parseInt(UserInfor?.roleID) === 1) ? <User /> : <Navigate replace to="/control-center/dashboard" />} />
            <Route path="/control-center/documentation/:main/:sub" element={<Documentation />} />
            <Route path="/control-center/workspace/:scriptID" element={<Workspace />} />
            <Route path="/control-center/workspace" element={<Workspace />} />
            <Route path="/control-center/connection/:param" element={<Connection />} />
            <Route path="/control-center/connection" element={<Connection />} />
            <Route path="/control-center/storage" element={<Storage />} />
            <Route path="/control-center/schedule" element={<Schedule />} />
            <Route path="*" element={<Navigate replace to="/verify-email" />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <BackDropLoading open={BackDrop} />
      <ConfirmDialogSimple obj={ConfirmDialog}/>
      <SnackbarAlertSimple obj={SnackbarAlert}/>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    UserInfor: state.UserInfor,
    BackDrop: state.BackDrop,
    ConfirmDialog: state.ConfirmDialog,
    SnackbarAlert: state.SnackbarAlert,
  }
}

export default connect(mapStateToProps)(App);
